module.exports = __webpack_public_path__ + "static/media/eventAssignOne.12302a2d.svg";